module.exports = __webpack_public_path__ + "files/ilunga.98d438410be92e72295ccf1f91a48153.pdf";